import src from "IMAGE";
export default { src, width: 718, height: 1517, blurWidth: 0, blurHeight: 0};
